import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { PollListItem } from "../user-polls.type";

@Component({
    selector: 'send-poll-reminder-dialog',
    templateUrl: './send-poll-reminder-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendPollReminderDialogComponent implements OnInit{

    poll: PollListItem
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: PollReminderData,
        public dialogRef: MatDialogRef<SendPollReminderDialogComponent>,
        protected translate: TranslateService,
    ) { }

    ngOnInit(): void {
        this.poll = this.data.poll;
    }

    close() {
        this.dialogRef.close(false);
    }
    sendReminder() {
        this.dialogRef.close(true);
    }
}

export interface PollReminderData {
    poll: PollListItem
}